import { render, staticRenderFns } from "./PlaceOrderDetail.vue?vue&type=template&id=5bac685e&scoped=true&"
import script from "./PlaceOrderDetail.vue?vue&type=script&lang=js&"
export * from "./PlaceOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./PlaceOrderDetail.vue?vue&type=style&index=0&id=5bac685e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bac685e",
  null
  
)

export default component.exports